export const required = (value) => {
  return (
    typeof value === "string"
      ? value.trim()
      : typeof value === "number"
      ? !isNaN(value)
      : Array.isArray(value)
      ? value.length
      : value
  )
    ? undefined
    : "Campo Obligatorio";
};

export const parse = (v) => (v ? Number(v) : undefined);

export const mustBeNumber = (value) => {
  if (!value || value.toString().trim() === "") {
    return undefined;
  }
  return isNaN(value) ? "Debe ser un numero" : undefined;
};

export const composeValidators =
  (...validators) =>
  (value, allValues) =>
    validators.reduce(
      (error, validator) => error || validator(value, allValues),
      undefined
    );

export const minValue = (min) => (value) => {
  if (!value || value.toString().trim() === "") {
    return undefined;
  }

  const numberValue = typeof value === "number" ? value : Number(value);

  return !isNaN(numberValue) && numberValue >= min
    ? undefined
    : `Valor minimo: ${min}`;
};

export const validateEmail = (message) => (value) => {
  if (!value || value.trim() === "") {
    return undefined;
  }

  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  if (!emailRegex.test(value.trim())) {
    return message || "Correo electrónico inválido";
  }

  return undefined;
};

export const phoneNumber = (message) => (value) => {
  if (!value || value.toString().trim() === "") {
    return undefined;
  }

  const isOnlyNumbers = /^\d+$/.test(value);
  return isOnlyNumbers && value.length === 8 ? undefined : "Número inválido";
};

export const mustBeInRange = (message, min, max) => (value) => {
  if (!value || value.toString().trim() === "") {
    return undefined;
  }

  if (value < min || value > max) {
    return "Valor fuera del rango permitido";
  } else {
    return undefined;
  }
};

export const noSpecialChars = (value) => {
  if (!value || value.trim() === "") {
    return undefined;
  }

  const regex = /^[A-Za-z0-9\sáéíóúÁÉÍÓÚ]+$/;
  if (!regex.test(value)) {
    return "No se permiten caracteres especiales.";
  }
  return undefined;
};

export const companyName = (value) => {
  if (!value || value.trim() === "") {
    return undefined;
  }
  const regex = /^[A-Za-z0-9\sáéíóúÁÉÍÓÚ.,&]+$/;
  if (!regex.test(value)) {
    return "Solo se permiten letras, números, espacios, punto, coma y &.";
  }
  return undefined;
};

export const validateDPI = (value) => {
  if (!value || value.toString().trim() === "") {
    return undefined;
  }

  const cuiRegExp = /^[0-9]{4}\s?[0-9]{5}\s?[0-9]{4}$/;
  if (!cuiRegExp.test(value)) {
    return "DPI inválido";
  }
  value = value.replace(/\s/g, "");
  const depto = parseInt(value.substring(9, 11), 10);
  const muni = parseInt(value.substring(11, 13));
  const numero = value.substring(0, 8);
  const verificador = parseInt(value.substring(8, 9));
  const munisPorDepto = [
    17, 8, 16, 16, 13, 14, 19, 8, 24, 21, 9, 30, 32, 21, 8, 17, 14, 5, 11, 11,
    7, 17,
  ];
  if (depto === 0 || muni === 0) {
    return "DPI inválido";
  }
  if (depto > munisPorDepto.length) {
    return "DPI inválido";
  }
  if (muni > munisPorDepto[depto - 1]) {
    return "DPI inválido";
  }
  let total = 0;
  for (let i = 0; i < numero.length; i++) {
    total += numero[i] * (i + 2);
  }
  const modulo = total % 11;
  if (modulo !== verificador) {
    return "DPI inválido";
  }
  return undefined;
};

export const validateNIT = (value) => {
  if (!value || value.toString().trim() === "") {
    return undefined;
  }

  const nitRegExp = /^[0-9]+(-?[0-9kK])?$/;
  if (!nitRegExp.test(value)) {
    return "NIT inválido";
  }
  value = value.replace(/-/, "");
  const lastChar = value.length - 1;
  const number = value.substring(0, lastChar);
  const expectedChecker = value.substring(lastChar, lastChar + 1).toLowerCase();
  let factor = number.length + 1;
  let total = 0;
  for (let i = 0; i < number.length; i++) {
    const character = number.substring(i, i + 1);
    const digit = parseInt(character, 10);
    total += digit * factor;
    factor = factor - 1;
  }
  const modulus = (11 - (total % 11)) % 11;
  const computedChecker = modulus === 10 ? "k" : modulus.toString();
  if (expectedChecker !== computedChecker) {
    return "NIT inválido";
  }
  return undefined;
};

export const validateAddress = (value) => {
  if (!value || value.trim() === "") {
    return undefined;
  }

  const regex = /^[A-Za-z0-9\sáéíóúÁÉÍÓÚñÑ.,-]+$/;
  if (!regex.test(value)) {
    return "Solo se permiten letras, números, espacios, guión, punto y coma.";
  }
  return undefined;
};

export const validateFecNact = (value) => {
  if (!value || value.toString().trim() === "") {
    return undefined;
  }

  const fecha = new Date();
  const year = fecha.getFullYear();
  const initialYear = parseInt(value.split("-")[0]);
  const menor = year - initialYear;
  const mayor = year - initialYear;
  if (initialYear > year || menor <= 18 || mayor >= 74) {
    return "Fecha de nacimiento inválido.";
  }
  return undefined;
};

export const minLength = (message, min) => (value) => {
  if (!value || value.toString().trim() === "") {
    return undefined;
  }

  if (value.length < min) {
    return message || `Valor del campo muy corto (min ${min} caracteres)`;
  }
  return undefined;
};

export const maxLength = (message, max) => (value) => {
  if (!value || value.toString().trim() === "") {
    return undefined;
  }

  if (value.length > max) {
    return message || `Valor del campo muy largo`;
  }
  return undefined;
};

export const validateUrl = (message) => (value) => {
  if (!value || value.trim() === "") {
    return undefined;
  }

  try {
    new URL(value.trim());
    return undefined;
  } catch (error) {
    return message || "URL inválida";
  }
};

export const validateDateFormat = (message) => (value) => {
  if (!value || value.trim() === "") {
    return undefined;
  }

  const dateRegex = /^[A-Za-z0-9\sáéíóúÁÉÍÓÚñÑ/-]+$/;

  if (!dateRegex.test(value.trim())) {
    return (
      message || "Solo se permiten letras, números, espacios, guiones y barras"
    );
  }
  return undefined;
};
